import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import { NewIcon } from '../../../../components/newIcon/icon';
import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { BUSINESS_CATEGORY_CONFIG } from './businessCategories.config';
import { CategoriesContainer, CategoryContainer } from './businessCategories.styled';

const { VITE_WEB_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const BusinessCategoriesTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Booking software for every type of<span> pet care business</span>
      </h2>
    </TextWithHighlight>
  );
};

export function BusinessCategories() {
  return (
    <WidthContainer noBackground>
      <SectionContainer title={BusinessCategoriesTitle}></SectionContainer>
      <CategoriesContainer>
        {BUSINESS_CATEGORY_CONFIG.map((category) => (
          <CategoryContainer
            href={category.link ? `${VITE_WEB_BASE_URL}${category.link}` : `${VITE_PARTNERS_BASE_URL}/sign-up`}
          >
            <NewIcon size="32px" type={category.icon} />
            <h3>{category.name}</h3>
            <p>{category.description}</p>
          </CategoryContainer>
        ))}
      </CategoriesContainer>
    </WidthContainer>
  );
}
